import {inject, Injectable} from '@angular/core';
import {StorageService} from './storage.service';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {MemoryService} from './memory.service';

function getWindow(): any {
  return window;
}

@Injectable({
  providedIn: 'root'
})
export class WindowReferenceService {
  http: HttpClient = inject(HttpClient);
  storageService = inject(StorageService);
  memoryService: MemoryService = inject(MemoryService);
  pushEvents: boolean = false;
  window!: any;
  poll!: any;
  // Set to false to prevent dataLayer messages from being sent to parent
  sendDataLayerMessages = true;

  // Set the prefix that will be used in the event name, and under which all
  // the dataLayer properties will be embedded
  dataLayerMessagePrefix = 'iframe';
  // parentOrigin = 'http://localhost';
  parentOrigin: any = '';

  // Maximum time in milliseconds to poll the parent frame for ready signal
  maxTime = 5000;

  // Don't touch anything that follows
  pollInterval = 200;
  parentReady = false;
  interval: any = 0;

  get nativeWindow() {
    return getWindow();
  }

  init(customerId: number) {
    if (customerId <= 0) {
      return;
    }

    // If not in iframe, do nothing
    try {
      if (window.top === window.self) {
        return;
      }
    } catch (e) {
    }

    this.window = this.nativeWindow;
    this.window.dataLayer = this.window.dataLayer || [];
    var gtmOrigin = this.memoryService.gtmOrigin;
    if (gtmOrigin) {
      this.http.get<boolean>(`${environment.cenplexBookingApiBaseUrl}/tagmanager/${customerId}`).subscribe(p => {
        this.pushEvents = p;
        if (this.pushEvents) {
          this.parentOrigin = gtmOrigin as string;
          // console.log("gtmOrigin: " + this.parentOrigin);
          if (this.parentOrigin && this.parentOrigin.startsWith('http')) {
            // console.log("FOUND: " + this.parentOrigin);
            this.maxTime = 2000;
            this.pollInterval = 200;
            this.interval = setInterval(() => {
              this.pollCallback(); // api call
            }, this.pollInterval);
            //// Start listening for messages from the parent page
            window.addEventListener('message', this.postCallback.bind(this));
            console.log('Tag manager service activated');
          }
        }
      });
    }
  }

  pollCallback() {
    // If maximum time is reached, stop polling
    this.maxTime -= this.pollInterval;
    if (this.maxTime <= 0) {
      clearInterval(this.interval);
    }
    // Send message to parent that iframe is ready to retrieve Client ID
    // console.log('POSTING childReady ' + this.maxTime);
    window.parent.postMessage('childReady', this.parentOrigin);
  }

  postCallback(event: any) {
    // console.log('RECEIVED ' + JSON.stringify(event));
    if (event.origin !== this.parentOrigin) return;
    if (event.data.event !== 'clientId' && event.data !== 'parentReady') return;

    if (event.data.event === 'clientId') {
      this.window.dataLayer.push({
        event: 'clientId',
        clientId: event.data.clientId
      });
    }

    if (event.data === 'parentReady' && !this.parentReady) {
      console.log('Tracking manager connected');
      clearInterval(this.interval);
      if (this.sendDataLayerMessages) this.startDataLayerMessageCollection(this);
      this.parentReady = true;
    }
  }

  startDataLayerMessageCollection(xy: WindowReferenceService) {
    // Send the current dataLayer content to top frame, flatten the object
    xy.window.dataLayer.forEach(function (obj: any) {
      var message = xy.createMessage(obj);
      if (message) window!.top!.postMessage(message, xy.parentOrigin);
    });
    // Create the push listener for future messages
    var oldPush = xy.window.dataLayer.push;
    xy.window.dataLayer.push = function () {
      var states = [].slice.call(arguments, 0);
      states.forEach(function (arg) {
        var message = xy.createMessage(arg);
        if (message) window!.top!.postMessage(message, xy.parentOrigin);
      });
      return oldPush.apply(xy.window.dataLayer, states);
    };
  }

  createMessage(obj: any) {
    if (!Array.isArray(obj) && typeof obj === 'object') {
      // console.log('createMessage RECEIVED: ' + JSON.stringify(obj));
      var flattenObj = JSON.parse(JSON.stringify(obj));
      var message = {} as any;
      // Add metadata about the page into the message
      message[this.dataLayerMessagePrefix] = {
        pageData: {
          url: document.location.href,
          title: document.title
        }
      };
      for (var prop in flattenObj) {
        if (flattenObj.hasOwnProperty(prop) && prop !== 'gtm.uniqueEventId') {
          if (prop === 'event') {
            message.event = this.dataLayerMessagePrefix + '.' + flattenObj[prop];
          } else {
            message[this.dataLayerMessagePrefix][prop] = flattenObj[prop];
          }
        }
      }
      if (!message.event) message.event = this.dataLayerMessagePrefix + '.Message';
      return message;
    }
    return false;
  }

  push(payload: any) {
    try {
      if (this.pushEvents) {
        this.window.dataLayer.push(payload);
      }
    } catch (error) {
      // console.log('Failed to forward treatment_selection');
    }
  }
}
